import React , {useEffect, useState} from 'react';

function ViewReviewDetails({id, onClose ,apiPath }) {


const apiUrl = process.env.REACT_APP_API_URL



 const [reviewData, setReviewData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchReview = async () => {
      try {
        const res = await fetch(`${apiUrl}${apiPath}${id}`);
        const result = await res.json();

        if (res.ok) {
          setReviewData(result.data); 
        } else {
          setError(result.message || "Failed to fetch review details");
        }
      } catch (err) {
        setError("Something went wrong while fetching data");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchReview(); // only call if id exists
  }, [id]);


  // console.log(reviewData);


  return (
    <div className="view-review-details-bg">

          {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p className="text-red-500">{error}</p>
        ) : (


      <div className="view-review-details-content">
        <h2 className="view-review-details-title">Review Details</h2>
      
      <div className='view-review-details-user-details-row'>

        <div className='view-rev-user-details'>
        <div>{reviewData.customerName}</div>
        <p>  <span>  {reviewData.serviceDate}</span>  <span> {reviewData.servicesName}</span> </p>

        {reviewData.BreedName &&  
        <p>{reviewData.BreedName} </p>
         }

           {reviewData.BikeName&&  
        <p>{reviewData.BikeName} </p>
         }

       </div>



       <div className='view-rev-rate-vale-box'> <i class="fa-solid fa-star"></i>  {reviewData.ratingNumber}</div>
      </div>


      <div className='view-rev-rate-text-details'>
            {reviewData.ratingMessage}

      </div>

        <button className="view-review-details-close-btn" onClick={onClose}>
          Close
        </button>
      </div>

        )}
    </div>
  );
}

export default ViewReviewDetails;
